import status from '../configuration/status.json';
import CONFIG from '../configuration/config';

function findStatusByValue(value) {
  const result = status.find((item) => item.value == value);
  return result ? result.status : 'Value not found';
}

function findValueStatus(data) {
  const result = CONFIG.STATUS.find((item) => item.name == data);
  return result ? result.value : 0;
}

function StatusInfo({ periodDB, programDB, programTypeDB, subPeriodDB, subStateManagment }) {
  const statusFinded = findStatusByValue(subStateManagment);
console.log(statusFinded);
  return (
    <>
      <div className="program-details-card">
        {/* <h2 className="program-title">{programDB}</h2>
            
            <div className="program-info">
            <p><strong>Tipo de programa:</strong> {programTypeDB}</p>
            {periodDB && <p><strong>Periodo:</strong> {periodDB + '-' + subPeriodDB}</p> } 
            </div> */}
        <div className="status-step">
          <p>Aquí verás el estado actual y lo que sigue en tu proceso </p>

          <ul className="items">
            {CONFIG.STATUS?.map((status, index) => (
              <li key={index} className={`item ${ (status.value <= findValueStatus(statusFinded)) ? '' : 'disabled'} `}>
                <div className="left">
                  <h3 className="title">{status.label}</h3>
                  <p className="description">
                    {(status.value <= findValueStatus(statusFinded)) ? status.text ?? '' :status.disabledText }
                  </p>
                </div>
                <div className="right">
                  {(status.value <= findValueStatus(statusFinded)) ? (
                    <i className="fa-solid fa-circle-check icon"></i>
                  ) : (
                    <i className="fa-solid fa-ellipsis"></i>
                    
                    
                  )}
                  {/* <p className="date">dd/mm/aaaa</p> */}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="status-step"></div>
    </>
  );
}

export default StatusInfo;
